import { css } from '@emotion/react'
import { type HTMLMotionProps, motion } from 'motion/react'
import { forwardRef } from 'react'

export interface MentionUserPlaceholderProps extends HTMLMotionProps<'div'> {}

export default forwardRef<HTMLDivElement, MentionUserPlaceholderProps>(
	function MentionUserPlaceholder({ ...props }: MentionUserPlaceholderProps, ref) {
		return (
			<div
				css={css`
					display: inline;
					padding: 0 2px;
				`}
				ref={ref}
			>
				<motion.div
					{...props}
					initial={{
						opacity: 0,
					}}
					animate={{
						opacity: 1,
					}}
					transition={{
						duration: 0.2,
					}}
					tabIndex={0}
					css={css`
						display: inline-flex;
						padding: 3px 4px;
						gap: 4px;
						align-items: center;
						white-space: nowrap;
						border-radius: 15px;
						background-color: var(--bg-on-body-2);
						transition: background-color 0.6s;
						position: relative;
						overflow: hidden;
					`}
				>
					<div
						css={css`
							width: 18px;
							height: 18px;
							border-radius: 18px;
							background-color: var(--bg-selected-blue);
						`}
					/>
					<div
						css={css`
							background-color: var(--bg-selected-blue);
							height: 12px;
							width: 35px;
							border-radius: 4px;
							padding-right: 3px;
						`}
					/>
				</motion.div>
			</div>
		)
	}
)
